import midAutumn from '@/views/act/midAutumnAccum2026/assets/locales/en.js'
import halloween from '@/views/act/halloween/assets/locale/en.js'
import novShopping from '@/views/act/novShopping2026/assets/locales/en.js'
export default {
  midAutumn,
  halloween,
  novShopping,
  "props": {
    "80102004": "Cash Voucher",
    "90501249": "Title – Mid-Autumn Moon",
    "80202003": "Weapon EXP Card LV3",
    "70100101": "Golden Diamond",
    "80102101": "Golden Diamond Draw Ticket",
    "70100004": "Cash",
    "1010504001": "P90 - Blooming Bones 5 days",
    "10101059": "M762 - Kitsune 7 days",
    "10101048": "Groza - Angel's Dream 7 days",
    "80103001": "Rank Protection",
    "80103002": "Ranked Double Points Card",
    "70100011": "Gold",
    "70100014": "Mystic Key",
    "81010999": "Universal Growth Coin",
    "70100013": "Mystic Voucher",
    "50120500": "Midsummer Pond: Painted Sprout",
    "90301912": "[Avatar Frame] Fortune Legend",
    "90501246": "[Title] Fortune Legend",
    "90301913": "[Avatar Frame] Fortune Master",
    "90501247": "[Title] Fortune Master",
    "90301914": "[Avatar Frame] Fortune Seeker",
    "90501248": "[Title] Fortune Seeker",
    "70100012": "Mystic Gem",
    "32701009": "Advanced Full Gear Pack",
    "70301008": "Dice",
    "90301917": "Exclusive Avatar Frame - [Shopping Pro]"
  },
  "payment": {
    "popupEvent": {
      "joinImmediate": "Participate Now",
      "noMoreTip": "Do not remind me again today."
    },
    "videoIntro": "Rainbow Diamond is the in-game currency and can be directly deducted when purchasing any paid in-game packages, no need to pay extra money!\n\nThe value of Rainbow Diamond is same as in-game cash payments, and purchasing Rainbow Diamond will have bonus rewards!\n\nExample: A package worth 9.99 USD in-game can also be purchased using Diamonds worth 9.99 USD, and topping up 9.99 USD worth of Rainbow Diamond will grant an additional 10% bonus.\n\nTips: First-time Rainbow Diamond recharges receive a maximum bonus of 100%!",
    "post": {
      "title": "More Content",
      "announcement": "Announcement",
      "faq": "FAQ"
    },
    "howToCheckUserId": "How to check character ID",
    "title": "Official Top-up, Bonus Rewards!",
    "noData": "No data",
    "tip": "Reminder",
    "notStart": "The event has not yet started.",
    "ended": "Ended",
    "maintainTip": "This payment channel is under maintenance. Please try again later.",
    "validateUser": {
      "title": "Character Verification",
      "enterUserId": "Please enter your Character ID",
      "desc": "Character ID",
      "submit": "Confirm",
      "noUserText": "Please search and confirm your information first",
      "queryLimitExceeded": "Too many requests. Please try again later.",
      "userNotFound": "Role ID does not exist. Please check and re-enter. (Click the question mark for tips on how to find your Role ID)"
    },
    "userDialog": {
      "id": "Character ID",
      "name": "Character Name",
      "confirmText": "Please confirm your character information",
      "confirmInput": "Confirm",
      "cancelInput": "Re-enter"
    },
    "payStatusDialog": {
      "cancelText": "Cancel",
      "paySuccess": "Top-up Completed!",
      "payFailed": "Top-up Failed",
      "paying": "Searching..."
    },
    "mallGuideDialog": {
      "title": "Top-Up Successful",
      "desc": "Your Rainbow Diamonds Top Up is complete. Head to the Membership Shop now to claim your rewards!",
      "claimLater": "Claim Later",
      "goNow": "Go Now"
    },
    "paymentMethod": {
      "title": "Select Payment Method",
      "recommend": "Recommended",
      "moreMethod": "Other Payment Methods",
      "confirm": "Confirm",
      "diankaTip1": "",
      "diankaTip2": ""
    },
    "product": {
      "title": "Select Top-up Package",
      "gift-single": "Bonus",
      "gift": "Bonus",
      "giftRegular": "Bonus",
      "giftActivity": "New Users: Extra",
      "giftActivityBadge": "New Users: Extra {num}",
      "giftRegularBadge": "+{num} Rainbow Diamonds",
      "giftPointsBadge": "+{num} Points",
      "coinTotal": "Total {total} ({coin}+{gift})",
      "coinTotalOnly": "Total {total}",
      "remaining": "{num} Times Left",
      "points": "Points",
      "summary": "Summary Information ",
      "selected": "Selected Package",
      "diamond": "Rainbow Diamond",
      "total": "Total Price",
      "confirm": "Confirm",
      "limit": "Purchase Limit"
    }
  },
  "header": {
    "memberStore": "Member Store"
  },
  "tabbar": {
    "recharge": "Top Up",
    "pointsMall": "Points Mall"
  },
  "footer": {
    "link": {
      "privacy": "Terms of User",
      "security": "Privacy Policy"
    },
    "jumpLink": {
      "fb": "https://www.facebook.com/profile.php?id=61576670225806",
      "fbGroup": "https://www.facebook.com/groups/miniworldroyale.en",
      "dc": "https://discord.gg/Eqje65WBpf",
      "yt": "https://www.youtube.com/{'@'}miniworldroyale.english",
      "tt": "https://www.tiktok.com/{'@'}miniworldroyale.eng",
      "privacy": "https://www.miniworldroyale.com/terms/19",
      "security": "https://www.miniworldroyale.com/terms/20"
    },
    "text": "If you encounter any issues during payment, please email ministarcustomerservice{'@'}gmail.com for assistance."
  },
  "customerServiceText": "Please contact us via email at ministarcustomerservice{'@'}gmail.com",
  "cancelText": "Back to Top-up",
  "api": {
    "networkError": "Network Error",
    "serverError": "Server Error, Error Code:"
  },
  "poolParty": {
    "box1": "Rare Chest",
    "box2": "Deluxe Chest",
    "loginDialog": {
      "title": "Verify your character to claim a welcome gift."
    },
    "prop": {
      "ACTIVITY_SWIM_RING": "Swim Ring",
      "ACTIVITY_WATER_GUN": "Water Gun",
      "ACTIVITY_SUN_UMBRELLA": "Beach Umbrella",
      "ACTIVITY_SWIM_GOGGLES": "Swimming Goggles",
      "80202003": "Weapon EXP Card LV3",
      "70100101": "Golden Diamond",
      "80102101": "Golden Diamond Draw Ticket",
      "80102004": "Cash Voucher",
      "80103001": "Rank Protection",
      "80103002": "Ranked Double Points Card",
      "70100011": "Gold",
      "70100014": "Mystic Key",
      "70100013": "Mystic Voucher",
      "81010999": "Universal Growth Coin",
      "90301907": "[Exclusive Reward] Avatar Frame – Pool Party"
    },
    "record": {
      "title": "Award Record",
      "detailTitle": "Reward Details",
      "dateTitle": "Claim Time",
      "noData": "No Data"
    },
    "btnCanReceive": "Available",
    "btnReceived": "Received",
    "btnNotReach": "Not achieved",
    "goRecharge": "Go to Top-Up",
    "welcomeReward": {
      "title": "Welcome Gift",
      "desc": "Claim after completing character verification."
    },
    "exchange": {
      "desc1": "Collect all Pool Party items to claim the exclusive event avatar frame—Pool Party—for free.",
      "desc2": "During the event, upon reaching a cumulative top-up of 1,000, 2,000, or 3,000 Rainbow Diamonds, you can claim an additional Pool Party item that you do not yet own.",
      "mainPropName": "[Exclusive Reward] Avatar Frame – Pool Party"
    },
    "dailyReward": {
      "day": "Day {day}",
      "desc": "Unlock a treasure chest after making your first purchase of Rainbow Diamonds each day."
    },
    "accumReward": {
      "itemTitle": "Pool Party Rewards",
      "itemCountText": "Accumulated top-ups of Rainbow Diamonds reach {need}({current}/{need})",
      "randomProp": "Random Pool Party Item",
      "randomPropNotOwned": "Random Pool Party Item (Unowned)"
    },
    "rule": {
      "item1": "During the event period, after completing your first Rainbow Diamonds Top Up each day, you can claim 1 Rare Chest. Each Rare Chest contains in-game item rewards and 1 exclusive Pool Party item.",
      "item2": "here are 4 different Pool Party items in total: Swim Ring, Water Gun, Beach Umbrella, and Swimming Goggles. These items can only be used on this event page. Collect all 4 different Pool Party items to obtain the event-exclusive reward: [Exclusive Reward] Avatar Frame – Pool Party.",
      "item3": "The 3rd and 7th chests are Deluxe Chests. They contain additional in-game item rewards and are guaranteed to grant a Pool Party item that you do not already own.",
      "item4": "During the event period, when your cumulative Rainbow Diamonds Top Up reaches 1,000 / 2,000 / 3,000, you can unlock additional Pool Party Packs. Each Pool Party Pack is guaranteed to contain a Pool Party item that you do not already own.",
      "item5": "The organizer reserves the right of final interpretation of this event.",
      "item6": ""
    }
  },
  "accumRecharge": {
    "countDownTitle": "Event Countdown",
    "countFuhao": "*",
    "clickHere": "Click Here",
    "introduce": "Head over to the online top-up page → [clickHere].Top up with selected amounts: 500/1000/2500/5000/10000 Rainbow Diamonds and receive corresponding in-game rewards!\nEvent Period: 2025/9/19 00:00:00 – 2025/10/6 23:59:59 (UTC+8)\nReward collection time will end on 2025/10/12 23:59:59 (UTC+8)",
    "goRecharge": "Go to Top-Up",
    "rewards": {
      "goRecharge": "Go to Top-Up",
      "record": "Award Record",
      "rewardsAll": "One-click Claim",
      "rewardTimes": "Available Times:",
      "btnStatus": {
        "canReceive": "Available Packs",
        "received": "Received Packs",
        "goRecharge": "Go to Top-Up"
      },
      "recordTable": {
        "name": "Recharge Packages",
        "details": "Reward details",
        "time": "Claim time"
      }
    },
    "rule": {
      "title": "Event Details:",
      "content": "1. How to Top Up: Click the [goRecharge] button above to access the online top-up page. Make sure to select one of the specified top-up tiers to qualify for the event!\n2. How to Claim Rewards: After completing a valid top-up, click the [Claim Reward] button above. Your rewards will be automatically sent to your in-game mailbox.\n3. Reward Limits: Each top-up tier has a limit on how many times you can receive rewards. Please refer to the table below for the specific Reward Claim Limits. Top-ups beyond the specified limit will not grant additional rewards."
    },
    "rewardsAllDialog": {
      "content": "One-click caim success!\nGo to [Award Record] to view reward details"
    },
    "rewardsTimes": {
      "times": "time"
    }
  },
  "accum": {
    "actStartCountDown": "Event Start Countdown",
    "actEndCountDown": "Event End Countdown",
    "rewardEndCountDown": "Reward Claim Countdown",
    "actEnded": "Event Ended",
    "clickHere": "Click Here",
    "goRecharge": "Go to recharge",
    "record": "Award Record",
    "rewardsAll": "One-click Claim",
    "rewards": {
      "eventDesc": "Use the official top-up channel[{clickHere}], and when your accumulated [Rainbow Diamonds] reach 100/300/500/1000/2000/3000/5000/10000, you can claim free rewards!(Only the base amount of [Rainbow Diamonds] is counted. Bonus [Rainbow Diamonds] are not included.)",
      "eventDescDuojin": "Rewards for this event have been boosted! We've added extra rewards for the brand-new duojin mode—come get it!",
      "duojin": "[Mystic Raid]",
      "eventTime": "Event Period: 12th June 2026, 01:00 - 22th June 2026, 00:59 (GMT+8)",
      "rewardEndTime": "Reward collection time will end on 29th June 2026, 00:59 (GMT+8)",
      "diffDiamond": "Top up more [diamondNum] Rainbow Diamonds to claim your next reward.",
      "btnCanReceive": "Available",
      "btnReceived": "Received",
      "btnNotReach": "Not achieved",
      "canReceiveAll": "You can claim all rewards"
    },
    "rewardsAllDialog": {
      "title": "Congratulations on your rewards",
      "content": "One-click caim success!\nGo to [record] to view reward details"
    },
    "recordDialog": {
      "title": "Award Record",
      "reachNode": "Recharge Records",
      "details": "Reward details",
      "time": "Claim time",
      "noData": "No data"
    },
    "rule": {
      "content": "1. How to Top Up:\nClick the {goRecharge} button above to access the official top-up platform and purchase Rainbow Diamonds!\n\n2. How to Claim Rewards:\nWhen your accumulated top-up amount reaches a reward tier, tap Claim. The rewards will be sent to your in-game mailbox. Don’t forget to log in to the game and collect them!\n\n3. Reward Limitation:\nEach accumulated top-up reward can only be claimed once and cannot be received repeatedly.\n\n4. Disclaimer:\nAll event content is subject to the actual display on the event page. The final interpretation right of this event belongs to the official team."
    }
  },
  "cny": {
    "goRecharge": "Go to recharge",
    "record": "Award Record",
    "remainingTimes": "Remaining draw attempts",
    "skipAnimation": "Skip draw animation",
    "lotteryOnce": "Draw 1 time",
    "lotteryOneKey": "One-click draw",
    "lottery": {
      "desc": "On the official recharge platform, every 500 Rainbow Diamonds recharged will grant one spin in the Lucky Wheel event.\n(Note: Only the base amount of Rainbow Diamonds recharged is counted; bonus Rainbow Diamonds are not included.)",
      "times": "Top-up accumulate period: December 24, 2025, 01:00 - January 13, 2026, 00:59 (GMT+8)\nReward Claim period: December 24, 2025, 01:00 - January 19, 2026, 00:59 (GMT+8)"
    },
    "lotteryRewardDialog": {
      "title": "Congratulations on your rewards"
    },
    "rewards": {
      "desc": "Accumulate 2, 5, 10, 20, 30, and 50 draws on this event page to receive additional [Progress Chests].",
      "times": "Top-up accumulate period: December 22, 2025, 00:00 - January 12, 2026, 00:59 (GMT+7)\nReward Claim period: December 22, 2025, 00:00 - January 18, 2026, 23:59 (GMT+7)",
      "lotteryNTimes": "Drawn {times} times",
      "reachNode": "Rewards Tiers",
      "rewardsAllDialog": {
        "content": "One-click caim success!\nGo to [Award Record] to view reward details"
      }
    },
    "rule": {
      "content": "1. During the event, for every 500 Rainbow Diamonds recharged on the official recharge platform, you will receive one Lucky Wheel spin. (Note: Only the base recharge amount is counted; bonus Rainbow Diamonds are not included.)\n2. Accumulating 2, 5, 10, 20, 30, and 50 spins on this event page will grant you additional [Progress Chest] rewards.\n3.Top-up accumulate period: December 24, 2025, 01:00 - January 13, 2026, 00:59 (GMT+8)\tReward Claim period: December 24, 2025, 01:00 - January 19, 2026, 00:59 (GMT+8)\n4. The official team reserves the right to final interpretation of this event."
    }
  },
  "mwr": {
    "actTimeDialogText": "The Event will Officially Launch at 01:00（GMT+8） on February 13. Stay Tuned!",
    "actTimeDialogText2": "",
    "save": "Save",
    "share": "Share",
    "mission": {
      "receiveRewardSuccess": "Reward claimed successfully.",
      "header": "Mission",
      "progress": "Progress",
      "btns": {
        "canReceive": "Get",
        "received": "Done",
        "notReach": "Not Achieved",
        "shareImmediate": "Share Now"
      },
      "list": {
        "1": {
          "key": "dailyLogin",
          "title": "Daily FREE REWARDS game login",
          "desc": "Daily"
        },
        "2": {
          "key": "loginDaysGt3",
          "title": "Accumulated Log-in to the game: 3 Days",
          "desc": "1-time Mission"
        },
        "3": {
          "key": "loginDaysGt7",
          "title": "Accumulated Log-in to the game: 7 Days",
          "desc": "1-time Mission"
        },
        "4": {
          "key": "shareMwr",
          "title": "Share Title/ Wrap to Social Media",
          "desc": "1-time Mission"
        },
        "5": {
          "key": "playedFiveNewMode",
          "title": "Play 3 different mode ",
          "desc": "Daily"
        },
        "6": {
          "key": "playedFiveNewMode",
          "title": "Play [Legend Arena] - 5 Times",
          "desc": "1-time Mission"
        }
      }
    },
    "turn": "Attack Count",
    "turnNum": "+{num}turn",
    "logout": "Log out",
    "home": {
      "statsPage": {
        "text": "Battle\nBook",
        "btnText": "See"
      },
      "dragonPage": {
        "text": "Defeat\nthe\nDragon",
        "btnText": "Go"
      }
    },
    "dragon": {
      "noTurn": "No attack attempts available.",
      "serverProgress": "Server Progress",
      "treasureBox": {
        "notReach": "Not Achieved",
        "received": "Done"
      },
      "rule": "All-Server players must unite to defeat the dragon. When the cumulative damage you deal to the dragon reaches certain thresholds, you can claim rewards from chests.\n1. Each attack on the dragon consumes 1 Attack Attempt.\n2. Attack Attempts can be obtained by completing missions.\n3. When the cumulative damage dealt to the dragon reaches [4.052], [10.130], and [20.260], the corresponding Progress Chests will be unlocked. Elites can then claim the rewards inside.\n4. When opening a chest, there is a chance for players to obtain an Ultra Rare Chest. The Ultra Rare Chest’s rewards will directly replace the original chest’s rewards.\n5. The drop rate for the Ultra Rare Chest is 0.001%, and its reward is 19,999 Gold Diamonds.\n6. When the evil dragon is defeated, all the players can recived reward by email.\n\nFAQ\n1. When does this event take place?\nEvent Period: February 9, 01:00 – March 2, 00:59 (GMT+8)\nReward Claim Period: February 9, 01:00 – March 9, 00:59 (GMT+8)\n\n2. How are rewards delivered?\nAll rewards during the event will be sent via in-game mail. Please remember to check your in-game mailbox.\n\n3. How to save a screenshot of the Annual Report page?\nThere is a \"Save\" option in the bottom right corner of the Annual Report page. Clicking it will auto-generate a screenshot. Press and hold the image to save it to your phone's gallery.\n\n4. If the dragon is defeated, will I still be able to participate in the event?\nIf the dragon is defeated, players can no longer participate in the event and will not be able to obtain chests. Please join the event promptly!\n\n5. Can the event rewards be claimed multiple times?\nEach milestone reward can be claimed only once. Repeatedly reaching the same milestone will not grant the reward again.\n\n6. Why did I complete the daily mission but my attack attempts didn't increase?\nAfter completing a mission, the system requires about 30 seconds to verify completion. Please wait a moment patiently.\n\n7. What happens if I don't claim my reward in time?\nPlease ensure you claim all rewards before March 2, 00:59 (GMT+8). Unclaimed rewards after the deadline will be considered forfeited and cannot be reissued.\n\n8. How can I contact customer support?\nPlease email ministarcustomerservice{'@'}gmail.com and provide your Player ID and the Reward Claim Time. Our team will assist you as soon as possible.\n",
      "boxRecord": {
        "title": "Reward History ",
        "box": "Chest",
        "reward": "Reward",
        "time": "Received date",
        "box1Name": "Chest I",
        "box2Name": "Chest II",
        "box3Name": "Chest III"
      },
      "superBox": {
        "text1": "The Evil Dragon has fallen!",
        "text2": "Server-wide rewards have been sent to your in-game mail, jump in and claim them now.",
        "text3": "Wishing you a happy New Year, Sharpshooter!"
      }
    },
    "stats": {
      "infos": {
        "page-1-left-title": "Battle Book",
        "page-1-left-desc": "Sharpshooter",
        "page-1-right-title": "Your Epic Journey Through 2025 Awaits",
        "page-2-left-title": "BATTLE HIGHLIGHT",
        "page-2-right-title": "HALL OF GLORY",
        "totalGameTime": "Total playtime",
        "totalKillCount": "Total kills",
        "alwaysPlayMode": "Most-played mode",
        "maxRankScore": "Highest rank achieved",
        "maxWeaponId": "Most-used weapon",
        "maxLongWinningCount": "Longest win streak",
        "maxLongLoginDays": "Longest consecutive login streak",
        "topFriendId": "Closest teammate",
        "totalWeaponCount": "Total number of weapons & firearms owned",
        "totalAvtCount": "Total number of skins and DIY equipment owned",
        "modeType-1": "Gunfight Showdown",
        "modeType-2": "Mini Ops",
        "modeType-3": "Savage Mutation",
        "hour": "Hours",
        "day": "Day"
      },
      "chenghao": {
        "isForty": "Lethal Contender",
        "isTwenty": "Elite Eliminator",
        "isGame100": "Global Apex",
        "modeID-1": "Gunfight - Tactical Architect",
        "modeID-2": "Mini Ops - The Last Survival",
        "modeID-3": "Savage - The Terminator",
        "weaponType-1": "SCAR - Battlefield Commander",
        "weaponType-2": "DMR - Precision Enforcer",
        "weaponType-3": "SR - One Shot One Kill",
        "weaponType-4": "Light MG - Suppressive Warlord",
        "weaponType-5": "SMG - Phantom Reaper",
        "weaponType-6": "Shotgun - Doorway Devastator",
        "weaponType-7": "Heavy MG - Iron Fortress",
        "weaponType-8": "Melee - Hand of God",
        "is10WValue": "Style Vanguard",
        "is15WValue": "Fashionista",
        "is20WValue": "Fashion Icon"
      },
      "chenghaoDesc": {
        "isForty": "Top 40% players with the highest kill rate",
        "isTwenty": "Top 20% players with the highest kill rate",
        "isGame100": "Top 100 ranks across all modes",
        "modeID-1": "Most played mode",
        "modeID-2": "Most played mode",
        "modeID-3": "Most played mode",
        "weaponType-1": "Most used gun type",
        "weaponType-2": "Most used gun type",
        "weaponType-3": "Most used gun type",
        "weaponType-4": "Most used gun type",
        "weaponType-5": "Most used gun type",
        "weaponType-6": "Most used gun type",
        "weaponType-7": "Most used gun type",
        "weaponType-8": "Most used gun type",
        "is10WValue": "Fashion score above 100,000",
        "is15WValue": "Fashion score above 150,000",
        "is20WValue": "Fashion score above 200,000"
      }
    }
  },
  "sf": {
    "endCountdown": "Countdown to end",
    "startCountdown": "Countdown to start",
    "ended": "The event has ended. Please claim your rewards in time.",
    "notStart": "The event has not yet started.",
    "day": "Day",
    "lottery": {
      "desc": "During the event period:\n1. For every top-up of 100 Rainbow Diamonds made on the official top-up website, you will receive 1 free [Firework].\n2. Each time you light a [Firework], you will obtain a random reward. Lighting [Firework] multiple times allows you to unlock milestone reward chests based on your progress.\n3. Note: Only the base Rainbow Diamonds from top-up transactions are counted. Bonus Rainbow Diamonds are not included. Please calculate your progress based on the base amount only.",
      "times": "Top-up Accumulation Period : February 9, 01:00 – March 2, 00:59 (GMT+8)\nReward Claim Period : February 9, 01:00 – March 9, 00:59 (GMT+8)",
      "remainingTimes": "Remaining attempts",
      "skipAnimation": "Skip Fireworks Animation"
    },
    "lotteryOnce": "Set off fireworks once",
    "lotteryOneKey": "Set off all fireworks",
    "rewards": {
      "canReceiveAll": "You can claim all rewards",
      "diffDiamond": "Need [diamondNum] [Fireworks] to claim the next reward",
      "lotteryNTimes": "{times}times"
    },
    "rule": {
      "content": "During the event period:\n1. For every top-up of 100 Rainbow Diamonds made on the official top-up website, you will receive 1 free [Firework].\n2. Each time you light a [Firework], you will obtain a random reward. Lighting [Firework] multiple times allows you to unlock milestone reward chests based on your progress.\n3. Note: Only the base Rainbow Diamonds from top-up transactions are counted. Bonus Rainbow Diamonds are not included. Please calculate your progress based on the base amount only."
    }
  },
  "wc2026": {
    "login": {
      "logintxt": "login",
      "inputCode": "Please enter verification code",
      "sendCode": "Send verification code to in-game mailbox",
      "submit": "Confirm",
      "cancel": "Cancel",
      "codeSent": "Verification code sent. Please check your in-game mailbox.",
      "loginSuccess": "Login Successful",
      "codeError": "Login Error",
      "emailPlaceholder": "Please enter account",
      "codePlaceholder": "Please enter verification code"
    },
    "logout": "[Log Out]",
    "intro": {
      "title": "Event Introduction",
      "contentText": "World Cup Cheer — Pick the team you support and win generous rewards! \r\nComplete daily missions to earn \"Cheer Chances,\" then cheer for your favored team on the schedule page. This World Cup features 48 teams across a 39-day schedule — the more matches you cheer for, the richer the milestone and leaderboard rewards you can unlock. \r\nLog in daily and keep cheering — support your team all the way to the final!"
    },
    "tabs": {
      "rewardHistory": "Reward History",
      "cheerCountLabel": "My Cheer Chances:",
      "goEarn": "Go Earn",
      "cheerPowCash": "Cheer Power Clash",
      "toCheer": "Cheer for a Team"
    },
    "rank": {
      "title": "Cheer Master Leaderboard",
      "rank": "Rank",
      "nickname": "Account Nickname",
      "winCount": "Cheer Success",
      "awardDes": "the top 50 players in the correct-prediction ranking can claim rewards",
      "des2": "Rank 4–10: 700 Gold Diamonds , Rank 11–25: 400 Gold Diamonds , Rank 26–50: 200 Gold Diamonds",
      "des1": "1st: 2000 Gold Diamond , 2nd: 1500 Gold Diamond , 3rd:1000 Gold Diamond"
    },
    "accountId": "Account ID",
    "noData": "No data available",
    "reaawardName": "Reward Name",
    "cheerTime": "Successful Cheers",
    "times": "Times",
    "bet": {
      "matchResult": {
        "pending": "Match Not Started",
        "cheered": "Cheered",
        "draw": "Match Cancelled",
        "win": "_team Wins",
        "daping": "Draw",
        "running": "Match Running"
      },
      "selectDate": "Schedule Date",
      "noMatches": "no match",
      "cheerSuccess": "cheer successfully",
      "confirm": {
        "content": "Confirm Cheer"
      }
    },
    "backTop": "Back to Top",
    "milestone,mainTitle": "Cheer to Claim Rewards",
    "milestone": {
      "totalCheer": "Cheer Milestone Rewards",
      "winCheer": "Success Milestone Rewards",
      "subTitleTotal": "The more matches you cheer for in total, the greater the rewards.",
      "subTitleWin": "The more successful cheers you accumulate, the greater the rewards.",
      "betTarget": "_n times",
      "title1": "Cheer_N_Times",
      "title2": "Successful_Chheer_N_Times"
    },
    "betTarget": "5 times",
    "received": "Claimed",
    "canReceive": "Available to Claim",
    "notReach": "Not Achieved",
    "rule": {
      "title": "Cheering Rules Details",
      "content": "1. How to Cheer\r\nEach match displays both teams' flags and names. Players select one team to cheer for. Each player may cheer only once per match, and Cheer Chances are deducted immediately upon submission — submissions cannot be canceled or modified.\r\nCheering opens up to 2 days before kickoff and closes once the match begins.\r\nThe knockout stage follows the same rules as the group stage: players pick one team to cheer for. There is no draw option in the knockout stage.\r\n\r\n2. Settlement and Rewards\r\nIf your cheered team wins, your cheer is successful and you receive in-game item rewards.\r\nIf the match ends in a draw (group stage only), players who cheered for either team receive rewards.\r\nCheer results are based on the official final match result.\r\nReaching cumulative cheer milestones unlocks the corresponding milestone rewards; the total number of successful cheers counts toward your leaderboard ranking.\r\n\r\n3. Notes\r\nIf a match is canceled, postponed, or ruled invalid, all Cheer Chances sent for that match will be fully refunded and will not count toward cheer results.\r\nAny abnormal farming of Cheer Chances or exploitation of bugs will result in the removal of those Cheer Chances and penalties to the relevant account, including bans.\r\nThe Operations Team reserves the right of final interpretation of this event."
    },
    "record": {
      "matchTime": "Match",
      "rewards": "Reward",
      "cheerTime": "Cheer Time",
      "cheerWinTab": "Cheer Rewards",
      "milestoneTab": "Milestone Rewards",
      "milestone": "Milestone",
      "receiveTime": "Receive Time",
      "target": "Target: "
    },
    "share": {
      "text": "Share",
      "title": "Successfully cheered _n_ matches and earned rewards ⚽",
      "description": "It's not luck — it's skill. Try to keep up!!"
    },
    "mail": {
      "title": "Congratulations! Your Cheers was successful!",
      "content": "Dear Sharpshooter,\r\n\r\nCongratulations on your successful support in the [Cheer Rush] event! The team you supported lived up to expectations and secured the victory. Your reward for this support session has been credited to your account. Please check it.\r\n\r\nWishing you a pleasant gaming experience.\r\n\r\nMini World Royale Operations Team"
    },
    "item": {
      "id_70100004": "Weapon EXP Card LV3",
      "id_70100101": "Gold Diamond",
      "id_80102101": "Golden Diamond Draw Ticket",
      "id_70100011": "Gold",
      "id_32204003": "Mid-Tier Safety Box（7 days）",
      "id_70100014": "Mystic Key",
      "id_81010999": "Universal Growth Coin",
      "id_90501207": "Title",
      "id_90301905": "Icon Frame",
      "id_90105303": "Avatar",
      "id_20500901": "Crosshairs-Football",
      "id_20400904": "Pendant-Whistle",
      "id_90301906": "Icon Frame",
      "id_90501208": "Title"
    },
    "task": {
      "wc_daily_login": "Daily Login",
      "wc_daily_play_mojin1": "Play 1 Mystic Raid",
      "wc_daily_play_mojin3": "Play 3 Mystic Raid",
      "wc_daily_play_any3": "Play any 3 matches",
      "wc_daily_online_60m": "Accumulate 60 minutes of online time",
      "wc_weekly_share": "Share Title/ Wrap to Social Media",
      "daily": "Daily Mission",
      "weekly": "Weekly Mission"
    },
    "receiveSuccess": "Claimed successfully",
    "error": {
      "code1104": "Time has expired",
      "code1105": "Already supported this match",
      "code1106": "Insufficient support attempts",
      "code1202": "Reward already claimed",
      "code1203": "Task not completed",
      "code1302": "Already Claimed",
      "code1303": "Conditions Not Met",
      "code1401": "Sharing too Frequently",
      "code13404": "Daily Limit Reached",
      "code13405": "Verification code Expired or Invalid",
      "code13406": "Too many failed attempts today. Please try again tomorrow or contact MOD.",
      "code501": "User check failed. User does not exist.",
      "code11402": "Login Expired",
      "code429": "Request too frequent. Please try again later."
    },
    "mailveritify_success": "Email Verification Successful"
  },
  "monopoly": {
    "rule": "Event Rules",
    "ruleContent": "1. This event will run from August 15th 01:00 to August 31st 00:59 (GMT+8). After the event ends, players will no longer be able to obtain dice through recharged diamonds, but can still use the remaining dice. After September 7th 00:59 (GMT+8), remaining dice will no longer be usable, and the leaderboard will be calculated. The event page will be completely closed on September 14th 00:59 (GMT+8).\n2. During the event, log in to the event page daily to claim 1 Normal Dice for free, up to 3 dice in total.\n3. Get 1 Normal Dice for every 100 Rainbow Diamonds topped up. For every 1,000 Rainbow Diamonds topped up, receive 1 Bonus Lucky Dice.\n4. Roll a Normal Dice to move a random 1–6 spaces.\n5. Lucky Dice allows you to choose any number from 1 to 6 before moving.\n6. The board contains 24 spaces. After completing a lap, you will continue from the Start and your total laps will be recorded.\n7. Landing on different spaces grants different rewards. Some special spaces trigger special events. Please refer to the in-game effect.\n8. Reach specific lap milestones to claim milestone rewards. More laps unlock better rewards.\n9. Ranking rewards will be distributed based on the final Lap Rankings after the event ends. Please claim your rewards before the event expires.\n10. Board rewards will be sent to your in-game mailbox after tapping Claim Rewards. Unclaimed rewards cannot be reissued after the event ends.",
    "rewardRecord": "Reward History",
    "rewardRecordDialog": {
      "reward": "Reward",
      "time": "Obtained Time",
      "status": "Status",
      "statusPending": "Unclaimed",
      "statusExtracted": "Claimed",
      "statusSent": "Sent",
      "empty": "No data"
    },
    "mainRule": "Log in daily to claim 1 Free Dice. Up to 3 Free Dice can be claimed during the event.\nGet 1 Dice for every 100 Rainbow Diamonds topped up.\nGet 1 Bonus Lucky Dice for every 1,000 Rainbow Diamonds topped up!",
    "logout": "Log Out",
    "loginTitle": "Character Verification",
    "accountId": "Character ID",
    "login": {
      "logintxt": "[Login]",
      "inputCode": "Enter Verification Code",
      "sendCode": "Send Code",
      "submit": "Confirm",
      "cancel": "Cancel",
      "codeSent": "Verification code sent. Please check your in-game mailbox.",
      "loginSuccess": "Login Successful",
      "codeError": "Login Error",
      "emailPlaceholder": "Please enter account",
      "codePlaceholder": "Enter Verification Code"
    },
    "normalDiceNum": "Normal Dice Remaining: {num}",
    "universalDiceNum": "Lucky Dice Remaining: {num}",
    "throwOnce": "Roll 1 Dice",
    "throwAll": "Roll All Dice",
    "pleaseLogin": "Please Log In First",
    "noDiceTitle": "You have no Dice remaining.",
    "noDiceTip1": "Get 1 {dice} for every {amount} Rainbow Diamonds topped up.",
    "noDiceTip2": "Get 1 Bonus {dice} for every {amount} Rainbow Diamonds topped up!",
    "noDiceNormal": "Dice",
    "noDiceUniversal": "Lucky Dice",
    "noDiceGoRecharge": "Go to recharge",
    "chooseStepsTitle": "Select the Lucky Dice Number",
    "chooseStepsOption": "Move Forward {steps} Spaces",
    "chooseStepsConfirm": "Confirm",
    "throwResultUnit": "{steps}",
    "throwAllRewardTip": "You have used all your Dice ({steps} spaces). Rewards Obtained",
    "rewardTitle": "Congratulations! You Received",
    "rewardEmpty": "No rewards this time",
    "mysteryEmptyTitle": "Exclusive Character already owned. Replaced with a Rare Chest.",
    "boxRewardTitleNormal": "Rare Chest Rewards",
    "boxRewardTitleLucky": "Deluxe Chest Rewards",
    "boxRewardTitleMystery": "Exclusive Anniversary Reward",
    "confirm": "Confirm",
    "dailyDiceClaimSuccess": "Normal Dice +1",
    "dailyDiceTipPrefix": "Log in daily to claim 1 Free Dice, up to ",
    "dailyDiceTipSuffix": " times.",
    "dailyDiceRemainPrefix": "Remaining Claims:",
    "dailyDiceClaim": "Claim",
    "extractRewards": "Claim Rewards",
    "extractRewardsDesc": "Tap the button to Claim all rewards to your in-game mailbox.",
    "extractSuccessTitle": "Rewards sent to your in-game mailbox",
    "noPendingRewards": "No rewards to claim",
    "circleRewards": "Complete more laps to unlock more rewards!",
    "circleAccumulated": "Total Laps: {count}",
    "circleLaps": "{count} Laps",
    "lapRewardAlready": "Reward already claimed",
    "lapRewardNotReached": "Lap requirement not met",
    "ranking": "Lap Rankings",
    "rankingTable": {
      "rank": "Rank",
      "nickname": "Character Name",
      "laps": "Laps",
      "time": "Completion Time (GMT+7)"
    },
    "rankingEmptyNickname": "Vacant",
    "rankingRewardTitleSingle": "Rank {rank} Reward",
    "rankingRewardTitleRange": "Rank {min}-{max} Reward",
    "moveSteps": "Move Forward {steps} Spaces",
    "moveStepsBack": "Move Back {steps} Spaces",
    "moveStepsCastle": "Anniversary Castle: Direct to {steps}",
    "notStart": "The event has not yet started.",
    "ended": "The event has ended. Please claim your rewards in time.",
    "startCountdown": "Countdown to start",
    "rechargeCountDown": "Top Up Bonus Dice Ends In",
    "diceCountDown": "Dice Usage Ends In",
    "countDownNotStarted": "Not started yet",
    "countDownEnded": "Ended",
    "day": "Day",
    "error": {
      "code401": "Login Expired",
      "code429": "Request too frequent. Please try again later.",
      "code2001": "The event has not started yet.",
      "code2002": "The event has ended.",
      "code2003": "Reward claim period has ended.",
      "code2004": "The event has ended.",
      "code2801": "Daily dice already claimed",
      "code2802": "Daily dice claim limit reached",
      "code2803": "Daily dice is not available now",
      "code2901": "You have no Dice remaining.",
      "code2902": "Invalid dice type",
      "code2903": "Invalid chosen steps",
      "code2904": "Lucky Dice cannot roll all",
      "code3001": "No rewards to claim",
      "code3002": "Claim failed. Please try again later.",
      "code3101": "Lap requirement not met",
      "code3102": "Reward already claimed",
      "code3201": "Rankings not settled yet",
      "code3202": "Ranking reward already sent"
    }
  },
  "ann2026": {
    "title": "Anniversary Ignite Plan",
    "flamePower": "Flame Power",
    "item": {
      "70100004": "Card Point",
      "80102101": "Golden Diamond Draw Ticket",
      "70100011": "Gold",
      "70100014": "Mystic Key",
      "70100013": "Mystic Voucher",
      "10101404": "AN94-Osmanthus",
      "50111700": "Sheng Yunzhi",
      "80103001": "Rank Protection",
      "1010102006": "M4-Cute Assault",
      "32701006": "Advanced Gear Pack",
      "90301910": "[Avatar Frame] Anniversary Celebration",
      "90301911": "[Avatar Frame]Blazing Storm",
      "90501244": "【Title】Eternal Blaze",
      "90501245": "【Title】From the Embers",
      "81010999": "Universal Growth Coin",
      "TBD_avatar_frame": "[Avatar Frame] Anniversary Celebration",
      "TBD_title": "Anniversary Celebration",
      "TBD_pendant": "Pendant-Whistle"
    },
    "home": {
      "serverPower": "Server-Wide Flame Power"
    },
    "hero": {
      "howToPlay": "Event Introduction",
      "logout": "[Log Out]",
      "login": "[Log In]"
    },
    "contribute": {
      "btnMain": "Contribute Power",
      "desc1": "Unite Your Might, Ignite the Light – Our Cake Burns Bright Tonight!",
      "desc2": "Available Flame Power: _n",
      "tabSupply": "Flame Supply",
      "tabRally": "Sharpshooters, Assemble!",
      "tabHistory": "Reward History"
    },
    "dialog": {
      "close": "Close"
    },
    "flameSupply": {
      "title": "Flame Supply",
      "subtitle": "COMPLETE TASK TO EARN POWER",
      "claimed": "Claimed",
      "completed": "Available to Claim",
      "incomplete": "Incomplete"
    },
    "eliteRally": {
      "subtitle": "INVITE FRIENDS BACK TO EARN REWARDS",
      "inviteOne": "Invite 1 friend",
      "inviteMany": "Invite {count} friends",
      "claimed": "Claimed",
      "claim": "Claim",
      "locked": "Locked",
      "itemName": "Item Name"
    },
    "rewardHistory": {
      "title": "Reward History",
      "reward": "REWARD",
      "receivedAt": "RECEIVED AT"
    },
    "congratulation": {
      "receivedReward": "RECEIVED REWARD"
    },
    "howToPlay": {
      "body": "🎉 Light Up!!! · Anniversary Ignition Plan\nThe Dark Star blew out the candles on our anniversary cake! Unite your Flame Power with Sharpshooters across the server, relight the cake, and ignite the \"1\" — let's celebrate Mini World Royale's first birthday!\n\n📅 Event Period\n Participation: Aug 15 – Sep 6 (GMT+7)\n Redemption: Until Sep 13 (GMT+7)\n ※ Unclaimed rewards will be forfeited.\n\n🔥 How to Play\n1. Earn Flame Power — Complete daily missions in Flame Supply.\n2. Light the Cake — Contribute your Flame Power to the Server-Wide Flame Power bar.\n3. Unlock Rewards —\n · Server-Wide: Hit 25% / 50% / 75% / 100% to light each cake layer. Everyone who joins unlocks rewards together! Ignite the \"1\" for the ultimate prize + exclusive Icon Frame and Title.\n · Personal: Your own contributions unlock personal milestone rewards. Contribute more, earn more!\n\n🤝 Sharpshooters, Reunite!\n Bring back friends who've been away. The more you bring back, the richer the rewards — hit the target for an exclusive Icon Frame and Title. It's not a party until the old crew comes home!\n\n🏆 Reward History\nEvery reward you've claimed can be found in Reward History."
    },
    "powerContributed": {
      "text": "Power Contributed: {count}"
    },
    "task": {
      "ann_daily_login": "Daily Login",
      "ann_daily_mojin_1": "Play the Mystic Raid Mode 1 Time",
      "ann_daily_mojin_3": "Play the Mystic Raid 3 Time",
      "ann_daily_play_any_1": "Play any 1 mode",
      "ann_weekly_share": "Share to Social Media",
      "ann_weekly_mojin_cake": "Obtain the Mystic Raid Red Item: Anniversary Cake",
      "dailyLabel": "Daily",
      "weeklyLabel": "Weekly"
    },
    "milestone": {
      "times": "_n times",
      "claim": "Available to Claim",
      "claimed": "Claimed",
      "notAchieved": "Not Achieved",
      "reward_1": "Avatar Frame",
      "reward_2": "10000 card point",
      "reward_3": "2 Golden Diamond Draw Ticket",
      "reward_4": "Title",
      "reward_5": "30 Mystic Voucher",
      "reward_6": "3 Golden Diamond Draw Ticket",
      "reward_7": "6 Million Gold",
      "reward_8": "3 Golden Diamond Draw Ticket",
      "reward_9": "Pendant",
      "reward_10": "1 Mystic Key",
      "reward_11": "AN94"
    },
    "footer": {
      "privacyPolicy": "Privacy Policy",
      "userAgreement": "User Agreement",
      "customerService": "Please contact us via email at ministarcustomerservice{'@'}gmail.com"
    },
    "accountId": "Account ID",
    "logout": "Log Out",
    "needLogin": "Please login to participate",
    "phase": "Phase",
    "timeRange": "Play time",
    "availableFire": "Available fire",
    "totalFire": "Total fire",
    "ignite": "Ignite",
    "share": "Share",
    "firstLoginReward": "Claim first login reward",
    "refresh": "Refresh",
    "receive": "Claim",
    "received": "Claimed",
    "notReady": "Not ready",
    "unlocked": "Unlocked",
    "locked": "Locked",
    "recallCount": "Recall count",
    "igniteOk": "Ignite success, consumed",
    "shareOk": "Shared successfully",
    "receiveOk": "Claimed successfully",
    "section": {
      "activity": "Activity info",
      "fire": "My firepower",
      "global": "Global stages",
      "task": "Tasks",
      "milestone": "Milestones",
      "recall": "Recall",
      "record": "Reward records"
    },
    "login": {
      "logintxt": "Login",
      "inputCode": "Please enter verification code",
      "sendCode": "Send verification code to in-game mailbox",
      "submit": "Confirm",
      "cancel": "Cancel",
      "codeSent": "Verification code sent. Please check your in-game mailbox.",
      "loginSuccess": "Login Successful",
      "emailVerificationSuccess": "Email Verification Successful",
      "birthday": "Happy Birthday!!!",
      "codeError": "Login Error",
      "emailPlaceholder": "Please enter account",
      "codePlaceholder": "Please enter the verification code.",
      "accountLabel": "Account ID",
      "codeLabel": "Verification Code"
    },
    "error": {
      "code401": "Login Expired",
      "code2201": "Task not completed",
      "code2202": "Reward already claimed",
      "code2301": "Not enough FlamePower!",
      "code2401": "This node has not been unlocked yet.",
      "code2402": "Reward already claimed",
      "code2501": "Conditions Not Met",
      "code2502": "Reward already claimed",
      "code2601": "Not enough sharpshooters have been recalled.",
      "code2602": "Reward already claimed",
      "code2801": "Reward already claimed",
      "code2001": "The event has not started yet.",
      "code2002": "The event has ended.",
      "code429": "Daily Limit Reached"
    }
  }
}
